module.exports = __webpack_public_path__ + "media/15.d5f86418.wav";